export default __webpack_public_path__ + "static/media/bullet.67d16dd5.svg";